import {
  BROWSER_TRANSLATION_SENTINEL_ATTR,
  BROWSER_TRANSLATION_SENTINEL_TEXT
} from '~/common/hooks/useBrowserTranslationActive';

// Hidden text node observed by `useBrowserTranslationActive`. Rendering it
// inside React's tree (rather than mutating document.body imperatively) keeps
// `hydrateRoot(document, …)` happy.
export function BrowserTranslationSentinel() {
  return (
    <span
      aria-hidden="true"
      {...{ [BROWSER_TRANSLATION_SENTINEL_ATTR]: '' }}
      style={{
        position: 'absolute',
        left: '-9999px',
        top: '-9999px',
        width: 1,
        height: 1,
        overflow: 'hidden',
        pointerEvents: 'none'
      }}
    >
      {BROWSER_TRANSLATION_SENTINEL_TEXT}
    </span>
  );
}
